import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { notification } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { adminSignInAction } from '../../actions/Admin/SignIn';

class SignUpPageAdmin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fieldsList: [],
            code: '',
            fieldSelct: '',
            formData: { userType: "admin" },
        };

    }
    componentWillMount() {

    }

    componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.signInUser && nextProps.signInUser.response.statusCode === 200) {
            notification.success({
                message: nextProps.signInUser.response.msg,
                className:'successNotification',
                duration: 3
            });
            console.log("nextProps.signInUser.response.data", nextProps.signInUser.response.data);
            localStorage.setItem('userData', JSON.stringify(nextProps.signInUser.response.data))
            localStorage.setItem('JWTTOKEN', nextProps.signInUser.response.data.token)
            localStorage.setItem('userLogin', true)
            this.props.history.push({
                pathname: "/admin/home",
                state: { userData: nextProps.signInUser.response.data }
            });

        } else if (nextProps && nextProps.signInUser && nextProps.signInUser.response.statusCode === 500) {
            notification.error({
                message: nextProps.signInUser.message,
                className:'errorNotification',
                duration: 3
            });
        }
    }

    handleChange = (e) => {
        e.preventDefault()
        const { formData } = this.state;
        formData[e.target.name] = e.target.value;
        this.setState({
            formData: formData
        })

    }

    signIn = (e) => {
        e.preventDefault();
        const { formData } = this.state;
        console.log("formData", formData);
        this.props.adminSignInAction(formData);
    }



    render() {
        const { formData } = this.state;
        return (
            <div className="all-page-wrapper">
                <div className="admin-page-wrapper">
                    <div className="container" >
                        <div className="row">
                            <div className="col-md-6 admin-column">
                                <form  onSubmit={this.signIn} validate>
                                    <div className="admin-form">
                                        <h3 className="admin-signin-heading">Admin Login</h3>
                                        <div className="form-group">
                                            <label>Email<span>*</span></label>
                                            <input type="text" className="form-control" name="email" onChange={this.handleChange}  placeholder="Email" value={formData.email} required/>
                                        </div>
                                        <div className="form-group">
                                            <label>Password<span>*</span></label>
                                            <input type="password" className="form-control" name="password" onChange={this.handleChange}  placeholder="Password" value={formData.password} required/>
                                        </div>
                                        <div className="form-group admin-btn-group">
                                            <Button className="admin-sign-in-btn" type="submit">Login</Button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>  
                    </div>
                </div>                    
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        signInUser: state.SignIn
    };
}

export default withRouter(connect(mapStateToProps, {
    adminSignInAction
})(SignUpPageAdmin));






// WEBPACK FOOTER //
// ./src/components/Admin/SignUpPageAdmin.js